var _path, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGreenTractor = function SvgGreenTractor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 13a3.667 3.667 0 0 0-3.667-3.667V7.5A.916.916 0 1 0 18 7.5v1.833H4.25a2.75 2.75 0 0 0-2.75 2.75.917.917 0 0 0 1.833 0 .917.917 0 0 1 .917-.916h15.583A1.844 1.844 0 0 1 21.3 14.1L19.875 16l1.54 1.002 1.352-1.802A3.686 3.686 0 0 0 23.5 13Z",
    fill: "#32C79D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 18.45,
    cy: 19.85,
    r: 4.15,
    fill: "#32C79D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m12.521 4.154 3.237 5.18H4.25V4.75A2.75 2.75 0 0 1 7 2h1.634a4.556 4.556 0 0 1 3.887 2.154Z",
    fill: "#32C79D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.583 17.583h-.091a4.54 4.54 0 0 0-.669-1.61l.067-.066a.916.916 0 0 0-1.296-1.296l-.067.066a4.54 4.54 0 0 0-1.61-.669v-.091a.917.917 0 0 0-1.834 0v.091a4.54 4.54 0 0 0-1.61.669l-.066-.067a.917.917 0 0 0-1.296 1.296l.067.067a4.54 4.54 0 0 0-.67 1.61h-.091a.917.917 0 0 0 0 1.834h.091a4.54 4.54 0 0 0 .669 1.61l-.067.066a.916.916 0 0 0 1.296 1.296l.067-.066a4.54 4.54 0 0 0 1.61.669v.091a.917.917 0 1 0 1.834 0v-.091a4.54 4.54 0 0 0 1.61-.669l.066.067a.917.917 0 0 0 1.296-1.296l-.066-.067a4.54 4.54 0 0 0 .669-1.61h.091a.917.917 0 0 0 0-1.834ZM7 21a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z",
    fill: "#32C79D"
  })));
};
export default SvgGreenTractor;